import { FormProps, PureFormProps } from '~/common/types/form'
import validator from '~/form/libs/validator'

import { Config } from '../types'

import displayNameValidator from './displayNameValidator'
import getNames from './getNames'

//ファイル系のname属性
const FILE_COMPONENT_NAMES = ['resume', 'portfolio', 'skillSheet']

const validationRulesComposer = (configs: Config[]) => {
  const validations: any[] = []

  configs.forEach((config) => {
    // 必須項目
    if (config.props.required) {
      // ファイル系の場合
      const displayName = displayNameValidator(config.component)
      const names = getNames(displayName)
      if (
        FILE_COMPONENT_NAMES.includes(config.component.displayName as string)
      ) {
        const urlName = names.find((name) => {
          return /.+Url$/.test(name)
        }) as keyof Pick<
          FormProps,
          'resumeUrl' | 'portfolioUrl' | 'skillSheetUrl'
        >
        const fileName = names.find((name) => {
          return /.+File$/.test(name)
        }) as keyof Pick<
          FormProps,
          'resumeFile' | 'portfolioFile' | 'skillSheetFile'
        >
        validations.push(validator.createRequiredUrlOrFile(urlName, fileName))
      } else {
        // ファイル系以外の場合
        names.forEach((name) => {
          if (name !== 'addressBuildingName') {
            validations.push(
              validator.createRequired(name as keyof PureFormProps)
            )
          }
        })
      }
    }
  })

  return validations
}

export default validationRulesComposer
